<template>
  <div class="h-100 pt-5 position-relative">
    <div
      id="main-img"
      class="aligner h-100"
      v-if="loaded"
      :class="bgClass"
      :style="{
        'background-image':
          'url(' + require('@/assets/images/CPR/E3/' + background) + ')',
      }"
    >
      <div :class="content.comment">
        <div
          v-if="content.title != '' && content.title != null"
          class="box-radius pt-2 pb-2 pl-4 pr-4 page-title font-weight-bold shadow"
          v-html="$helpers.translate(content.title, lang)"
        ></div>
        <CRow
          id="content-container"
          class="justify-content-md-center position-relative pt-2 pb-2 pl-4 pr-4"
        >
          <div id="focus-moving"></div>
          <div id="focus-moving-header-left"></div>
          <div id="box-slider-moving"></div>
          <div id="dot"></div>
          <CCol
            v-if="content.image != undefined && content.image.url != undefined"
            :class="[content.image.class, 'col-5']"
          >
            <img :src="baseUrl + '/cpr/Image/' + content.image.url" />
            <!--<img :src="require('@/assets/images/CPR/E3/'+content.image.url)" />-->
          </CCol>
          <CCol
            class="content"
            v-for="(item, index) in content.paragraph"
            :key="index"
            :class="[
              {invisible: numStep < index},
              {'animate__animated animate__fadeIn': numStep == index},
              item.class,
              {
                'col-md-7 col-sm-12':
                  content.image != undefined && content.image.url != undefined,
              },
              {
                'col-md-12': !(
                  content.image != undefined && content.image.url != undefined
                ),
              },
            ]"
          >
            <div
              v-for="(obj, index) in item.line"
              class="description"
              :key="index"
              :class="[obj.class]"
              v-html="$helpers.translate(obj.text, lang)"
            ></div>
          </CCol>
        </CRow>
      </div>
      <button
        class="btn-control btn-prev animate__animated animate__fadeInLeft"
        type="button"
        @click.prevent="onPrev()"
      >
        <i class="fa fa-play"></i>
      </button>
      <CButton
        class="btn-control btn-next animate__animated animate__fadeInRight"
        @click="onNext()"
      >
        <font-awesome-icon :icon="['fas', 'play']" />
      </CButton>
      <CButton
        @click="onClose"
        class="btn-control btn-close animate__animated animate__fadeInRight"
      >
        <font-awesome-icon :icon="['fas', 'times']" />
      </CButton>
      <CButton
        @click="onDownload"
        class="btn-control btn-bookmark animate__animated animate__fadeInRight"
      >
        <font-awesome-icon :icon="['fas', 'bookmark']" />
      </CButton>
      <CButton
        @click="onReload"
        class="btn-control btn-restart animate__animated animate__fadeInRight"
      >
        <font-awesome-icon :icon="['fas', 'redo-alt']" />
      </CButton>
    </div>
  </div>
</template>
<script>
import Axios from 'axios';
import {mapGetters} from 'vuex';
export default {
  name: 'LessonContent',
  components: {},
  data() {
    return {
      numStep: 0,
      numProgress: 0,
      courseSection: 0,
      content: [],
      background: '',
      bgClass: '',
      lang: 'th',
      loaded: false,
      data: [],
      closeAction: '',
      next: '',
      prev: '',
      attach: '',
      baseUrl: process.env.VUE_APP_URL_SOUND,
      userTemplateData: [],
      templateId: '',
      paticipationId: '',
      interactionId: '',
      startTime: '',
      courseCode: '',
    };
  },
  computed: {
    ...mapGetters({
      getTemplatev3: 'v3/getTemplates',
      templateContent: 'template/getTemplateContent',
      loadingGetter: 'template/loadingGetter',
      getTemplateCriteria: 'template/getUserTemplate',
    }),
  },
  watch: {
    $route: function (to, from) {
      this.onLoadContent();
    },
    // templateContent: function (val) {
    //   if (!val.enable) {
    //     this.$router.push({name: val.navigate.close.action});
    //   } else {
    //     this.onReload();
    //     this.templateId = val._id;
    //     this.next = val.navigate.next.action;
    //     this.prev = val.navigate.previous.action;
    //     this.closeAction = val.navigate.close.action;
    //     this.background = val.content.image[0].url;
    //     this.loaded = true;
    //     this.data = val.content.page;
    //     this.content = this.data[this.numProgress];
    //     this.bgClass = this.content.animation.bg;

    //     if (val.attachFile != null) {
    //       this.attach = val.attachFile;
    //     }
    //     this.courseSection =
    //       this.$store.getters['necessary/getLerningCourse'].groups[0].code;
    //     this.$store.dispatch('template/createUserTemplateData', {
    //       code: this.courseCode,
    //       template: this.templateId,
    //       section: this.courseSection,
    //     });
    //   }
    // },
    getTemplatev3(val) {
      console.log(val, 'gettemp');

      const template = val.templates[0];

      if (!template.enable) {
        this.$router.push({name: 'v4' + template.navigate.close.action});
      } else {
        this.onReload();
        this.templateId = val._id;
        this.next = template.navigate.next.action;
        this.prev = template.navigate.previous.action;
        this.closeAction = template.navigate.close.action;
        this.background = template.content.image[0].url;
        this.loaded = true;
        this.data = template.content.page;
        this.content = this.data[this.numProgress];
        this.bgClass = this.content.animation.bg;

        if (template.attachFile != null) {
          this.attach = template.attachFile;
        }
        // this.courseSection =
        //   this.$store.getters['necessary/getLerningCourse'].groups[0].code;
        // this.$store.dispatch('template/createUserTemplateData', {
        //   code: this.courseCode,
        //   template: this.templateId,
        //   section: this.courseSection,
        // });
      }
    },
    // getTemplateCriteria: function (val) {
    //   //this.userTemplateData = val;
    //   val.data.condition.criteriaType.filter((item, index) => {
    //     if (
    //       this.$helpers.translate(item.criteria.name, 'en') == 'paticipation'
    //     ) {
    //       this.paticipationId = item.criteria._id;
    //     } else if (
    //       this.$helpers.translate(item.criteria.name, 'en') == 'interaction'
    //     ) {
    //       this.interactionId = item.criteria._id;
    //     }
    //   });
    // },
  },
  mounted() {
    window.addEventListener('resize', this.onFocus);
    window.addEventListener('resize', this.onFocusHeaderLeft);
    window.addEventListener('resize', this.onBoxSliderMoving);
    window.addEventListener('resize', this.onSlideLeft);
    window.addEventListener('resize', this.onDot);
    this.onLoadContent();
  },
  created() {
    this.startTime = this.$helpers.getDateFormat();
    this.courseCode = this.$store.getters['necessary/getLerningCourse']._id;
  },
  updated: function () {
    this.$nextTick(function () {
      this.onFocus();
      this.onFocusHeaderLeft();
      this.onBoxSliderMoving();
      this.onSlideLeft();
      this.onDot();
    });
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.onFocus);
    window.removeEventListener('resize', this.onFocusHeaderLeft);
    window.removeEventListener('resize', this.onBoxSliderMoving);
    window.removeEventListener('resize', this.onSlideLeft);
    window.removeEventListener('resize', this.onDot);
  },
  methods: {
    onLoadContent() {
      // let body = {};
      // body.code = this.courseCode;
      // body.templateCode = this.$route.params.id;
      // this.$store.dispatch('template/fetchContent', body);
      this.$store.dispatch('v3/fetchTemplateByCode', this.$route.params.id);
    },
    onDownload() {
      // Axios({
      //   url: this.baseUrl + this.attach.path + this.attach.name,
      //   method: 'GET',
      //   responseType: 'blob',
      // }).then((response) => {
      //   var fileURL = window.URL.createObjectURL(new Blob([response.data]));
      //   var fileLink = document.createElement('a');
      //   fileLink.href = fileURL;
      //   fileLink.setAttribute('download', 'CPR.pdf');
      //   document.body.appendChild(fileLink);
      //   fileLink.click();
      // });
    },
    onDot() {
      if (this.jquery('.dot-top:not(.invisible)').length > 0) {
        const refPosTop = this.jquery('.dot-ref').offset().top;
        const refHeight = this.jquery('.dot-ref').outerHeight();

        const start = refPosTop + refHeight;
        const end = this.jquery('.dot-top:not(.invisible)').offset().top;

        const height = end - start - 10;
        this.jquery('#dot').css({
          top: start - 5 + 'px',
          height: height + 'px',
        });
        this.jquery('#dot').slideDown();
      } else {
        this.jquery('#dot').hide();
      }
    },
    onSlideLeft() {
      if (this.jquery('.slide-thumb-left:not(.invisible)').length > 0) {
        //this.jquery(".slide-thumb-body").addClass("ml30");
        //this.onFocus();
      }
    },
    onFocus() {
      if (this.jquery('.focus:not(.invisible):last').length > 0) {
        const width = this.jquery('.focus:not(.invisible):last').outerWidth();
        const height =
          this.jquery('.focus:not(.invisible):last').outerHeight() + 30;
        const top =
          this.jquery('.focus:not(.invisible):last').position().top +
          parseInt(
            this.jquery('.focus:not(.invisible):last').css('marginTop'),
            10
          );

        if (this.jquery('.focus:not(.invisible):last').is('[class*="ml-"]')) {
          const left =
            this.jquery('.focus:not(.invisible):last').position().left +
            parseInt(
              this.jquery('.focus:not(.invisible):last').css('marginLeft'),
              10
            );
          this.jquery('#focus-moving').css({
            left: left + 10 + 'px',
          });
        } else {
          this.jquery('#focus-moving').css({
            left: 'auto',
          });
        }

        if (this.jquery('#focus-moving').css('display') == 'none') {
          this.jquery('#focus-moving').fadeIn();
        }
        this.jquery('#focus-moving').css({
          top: top - 10 + 'px',
          width: width + 'px',
          height: height + 'px',
        });
      } else {
        this.jquery('#focus-moving').hide();
      }
    },
    onBoxSliderMoving() {
      if (this.jquery('.box-slider-content:not(.invisible)').length > 0) {
        const width = this.jquery('.box-slider-header').outerWidth();
        var height = 0;

        if (this.jquery('#box-slider-moving').outerHeight() == 0) {
          height =
            this.jquery('.box-slider-header').outerHeight() +
            this.jquery(
              '.box-slider-content:not(.invisible):last'
            ).outerHeight();
        } else {
          height =
            this.jquery('#box-slider-moving').outerHeight() +
            this.jquery(
              '.box-slider-content:not(.invisible):last'
            ).outerHeight();
        }

        const top = this.jquery('.box-slider-header').position().top;
        if (this.jquery('#box-slider-moving').css('display') == 'none') {
          this.jquery('#box-slider-moving').fadeIn();
        }
        this.jquery('#box-slider-moving').css({
          top: top + 'px',
          width: width + 'px',
          height: height + 'px',
        });
      } else {
        this.jquery('#box-slider-moving').hide();
      }
    },
    onFocusHeaderLeft() {
      if (this.jquery('.focus-header-left:not(.invisible):last').length > 0) {
        const width =
          this.jquery('.focus-header-left:not(.invisible):last').outerWidth() +
          30;
        const height =
          this.jquery('.focus-header-left:not(.invisible):last').outerHeight() +
          30;
        const top =
          this.jquery('.focus-header-left:not(.invisible):last').position()
            .top +
          parseInt(
            this.jquery('.focus-header-left:not(.invisible):last').css(
              'marginTop'
            ),
            10
          );

        if (
          this.jquery('.focus-header-left:not(.invisible):last').is(
            '[class*="ml-"]'
          )
        ) {
          const left =
            this.jquery('.focus-header-left:not(.invisible):last').position()
              .left +
            parseInt(
              this.jquery('.focus-header-left:not(.invisible):last').css(
                'marginLeft'
              ),
              10
            );
          this.jquery('#focus-moving-header-left').css({
            left: left + 10 + 'px',
          });
        } else {
          this.jquery('#focus-moving-header-left').css({
            left: 'auto',
          });
        }
        if (this.jquery('#focus-moving-header-left').css('display') == 'none') {
          this.jquery('#focus-moving-header-left').fadeIn();
        }
        this.jquery('#focus-moving-header-left').css({
          top: top - 10 + 'px',
          width: width + 'px',
          height: height + 'px',
        });
      } else {
        this.jquery('#focus-moving-header-left').hide();
      }
    },
    onReload() {
      this.numProgress = 0;
      this.numStep = 0;
      this.content = this.data[this.numProgress];
    },
    onNext() {
      var endContent = false;
      if (this.numProgress <= this.data.length - 1) {
        if (this.data[this.numProgress] != undefined) {
          if (
            this.numStep <
            parseInt(this.data[this.numProgress].paragraph.length) - 1
          ) {
            this.numStep += 1;
          } else if (this.data[this.numProgress + 1] != undefined) {
            this.numStep = 0;
            this.numProgress += 1;
          } else {
            endContent = true;
          }

          this.content = this.data[this.numProgress];
          this.bgClass = this.content.animation.bg;
        } else {
          endContent = true;
        }
        if (endContent) {
          // const userCriteria = {
          //   code: this.courseCode,
          //   template: this.templateId,
          //   section: this.courseSection,
          //   answering: [],
          //   startTime: this.startTime,
          //   endTime: this.$helpers.getDateFormat(),
          //   condition: [
          //     {
          //       criteria: this.paticipationId, // การวัดผลด้านต่างๆ
          //       val: 15,
          //     },
          //     {
          //       criteria: this.interactionId,
          //       val: 85,
          //     },
          //   ],
          // };

          // this.$store.dispatch('template/saveUserTemplateData', userCriteria);
          if (this.next == 'CPR-SUM03') {
            this.$router.push('/v4/CPR/summary/' + this.next);
          } else {
            this.$router.push('/v4/CPR/lessonContent/' + this.next);
          }
        }
      }
    },
    onPrev() {
      if (this.numProgress > 0) {
        if (this.numStep > 0) {
          this.numStep -= 1;
        } else if (this.numStep == 0) {
          this.numProgress -= 1;
          this.numStep = this.data[this.numProgress].paragraph.length - 1;
        }
        this.content = this.data[this.numProgress];
        this.bgClass = this.content.animation.bg;
      } else {
        this.$router.push('/v4/CPR/lessonContent/' + this.prev);
      }
    },
    onClose() {
      this.$router.push({
        name: 'v4CPRKids',
      });
    },
  },
};
</script>
<style scoped>
@import '../../../assets/scss/CPR/style.scss';
body {
  color: #3c4b64;
}
.mt10 {
  margin-top: 10% !important;
}
.ml30 {
  margin-left: 30% !important;
}
#main-img {
  transition: all 1s;
  background-size: 100%;
  background-repeat: no-repeat;
  min-height: 100vh;
}
.box-slider-header {
  background: #fff;
  border-radius: 30px;
  font-size: 24px;
  font-weight: 400;
}
#box-slider-moving {
  background-color: hsla(0, 0%, 92.2%, 0.5);
  -webkit-box-shadow: 0 10px 80px rgba(0, 0, 0, 0.05);
  box-shadow: 0 10px 80px rgba(0, 0, 0, 0.05);
  opacity: 1;
  backdrop-filter: blur(10px);
  -webkit-backdrop-filter: blur(10px);
  border-radius: 30px;
  color: #000;
  position: absolute;
  z-index: 0;
  display: none;
  transition: 0.5s all ease;
}
.box-slider-content {
  border-radius: 30px;
  font-size: 25px;
}
.description {
  font-size: 25px;
}
@media screen and (max-width: 1440px) {
  .description,
  .box-slider-content {
    font-size: 18px !important;
  }
}
.bg-center {
  background-position: center;
  background-size: 100%;
}
.bg-bottom {
  background-position: center bottom;
  background-size: 100%;
}
.bg-top {
  background-position: center top;
  background-size: 100%;
}
.p-box:first-child {
  padding: 1.5rem 1.5rem 0 1.5rem !important;
}
.p-box:last-child {
  padding: 1.5rem 1.5rem 1.5rem 1.5rem !important;
}
.bg-zoom-left {
  background-position: center left !important;
  background-size: 220% !important;
}
.bg-zoom-top-left {
  background-position: top left !important;
  background-size: 220% !important;
}
.bg-zoom-bottom-left {
  background-position: center left !important;
  background-size: 220% !important;
}
.bg-zoom-center-center {
  background-position: center center !important;
  background-size: 220% !important;
}
.bg-zoom-center-right {
  background-position: center right !important;
  background-size: 220% !important;
}
#focus-moving-header-left .description {
  padding-left: 50px !important;
}
#focus-moving-header-left {
  background-color: hsla(0, 0%, 92.2%, 0.5);
  -webkit-box-shadow: 0 10px 80px rgba(0, 0, 0, 0.05);
  box-shadow: 0 10px 80px rgba(0, 0, 0, 0.05);
  opacity: 1;
  backdrop-filter: blur(10px);
  -webkit-backdrop-filter: blur(10px);
  border-radius: 30px;
  color: #000;
  position: absolute;
  z-index: 0;
  display: none;
  transition: 0.5s all ease;
}
#focus-moving-header-left::before {
  background: #fff;
  content: '';
  width: 30px;
  height: 100%;
  float: left;
  border-radius: 30px 0 0 30px;
}
.text-size-18 {
  font-size: 18px !important;
}
.zoom-bg {
  background-position: center;
  background-size: 160% !important;
}
.toggle {
  border: 1px solid #fff;
}
.dot-before::before {
  content: '\A';
  width: 10px;
  height: 10px;
  border-radius: 50%;
  background: #3c4b64;
  display: inline-block;
  margin-left: -15px;
  margin-right: 5px;
  padding: 5px;
}
#focus-moving {
  width: 100%;
  height: 100px;
  background-color: hsla(0, 0%, 92.2%, 0.5);
  -webkit-box-shadow: 0 10px 80px rgba(0, 0, 0, 0.05);
  box-shadow: 0 10px 80px rgba(0, 0, 0, 0.05);
  opacity: 1;
  backdrop-filter: blur(10px);
  -webkit-backdrop-filter: blur(10px);
  border-radius: 30px;
  color: #000;
  font-size: 28px;
  position: absolute;
  z-index: 0;
  display: none;
  transition: 0.5s all ease;
}
.shadow {
  box-shadow: 0px -5px 5px 1px rgba(255, 255, 255, 0.9),
    /* top shadow */ -5px 0px 5px 1px rgba(255, 255, 255, 0.9),
    /* left shadow */ 5px 0px 5px 1px rgb(200, 54, 97),
    /* right shadow */ 0px 5px 5px 1px rgb(200, 54, 97) !important; /* bottom shadow */
  -webkit-box-shadow: 0px -5px 5px 1px rgba(255, 255, 255, 0.9),
    /* top shadow */ -5px 0px 5px 1px rgba(255, 255, 255, 0.9),
    /* left shadow */ 5px 0px 5px 1px rgb(200, 54, 97),
    /* right shadow */ 0px 5px 5px 1px rgb(200, 54, 97) !important; /* bottom shadow */
  -moz-box-shadow: 0px -5px 5px 1px rgba(255, 255, 255, 0.9),
    /* top shadow */ -5px 0px 5px 1px rgba(255, 255, 255, 0.9),
    /* left shadow */ 5px 0px 5px 1px rgb(200, 54, 97),
    /* right shadow */ 0px 5px 5px 1px rgb(200, 54, 97) !important; /* bottom shadow */
}
.shadow-blue {
  box-shadow: 0px -5px 5px 1px rgba(255, 255, 255, 0.9),
    /* top shadow */ -5px 0px 5px 1px rgba(255, 255, 255, 0.9),
    /* left shadow */ 5px 0px 5px 1px rgb(159, 206, 206),
    /* right shadow */ 0px 5px 5px 1px rgb(159, 206, 206) !important; /* bottom shadow */
  -webkit-box-shadow: 0px -5px 5px 1px rgba(255, 255, 255, 0.9),
    /* top shadow */ -5px 0px 5px 1px rgba(255, 255, 255, 0.9),
    /* left shadow */ 5px 0px 5px 1px rgb(159, 206, 206),
    /* right shadow */ 0px 5px 5px 1px rgb(159, 206, 206) !important; /* bottom shadow */
  -moz-box-shadow: 0px -5px 5px 1px rgba(255, 255, 255, 0.9),
    /* top shadow */ -5px 0px 5px 1px rgba(255, 255, 255, 0.9),
    /* left shadow */ 5px 0px 5px 1px rgb(159, 206, 206),
    /* right shadow */ 0px 5px 5px 1px rgb(159, 206, 206) !important; /* bottom shadow */
}
.title {
  text-align: center;
  font-size: 34px;
  /*background: transparent
    linear-gradient(146deg, #d9d9d9 0%, var(--unnamed-color-e2e2e2) 100%) 0% 0%
    no-repeat padding-box; */
  /* box-shadow: 0px 0px 28px #FFF, 0 -10px 20px -5px #7b272c; */
  /*background: transparent linear-gradient(146deg, #d9d9d9 0%, #e2e2e2 100%) 0%
    0% no-repeat padding-box; */
  background: #f3f3f3;
  border-radius: 80px;
  opacity: 1;
  width: auto;
  position: absolute;
  /* top: 50%; */
  /* left: 50%; */
  /* margin-left: -20%; */
  padding: 10px;
  /* margin-top: -80px;*/
}
.content {
  z-index: 1;
}
.btn-control {
  background: #d9d9d9 0% 0% no-repeat padding-box;
  box-shadow: -2px -2px 5px #ffffff80;
  border: 1px solid #ffffff40;
  width: 45px;
  height: 45px;
  border-radius: 50%;
  position: absolute;
  z-index: 99;
  color: #949494;
}
.btn-prev {
  top: 50%;
  margin-top: -12.5px;
  left: 20px;
}
.btn-prev svg {
  transform: rotate(180deg);
}
.btn-next {
  top: 50%;
  margin-top: -12.5px;
  right: 20px;
}
.btn-sound {
  bottom: 5%;
  right: 20px;
}
.btn-close {
  top: 12%;
  right: 20px;
}
.btn-restart {
  bottom: 25%;
  right: 20px;
}
.btn-bookmark {
  bottom: 15%;
  right: 20px;
}
.glass {
  background-color: hsla(0, 0%, 92.2%, 0.5);
  -webkit-box-shadow: 0 10px 80px rgba(0, 0, 0, 0.05);
  box-shadow: 0 10px 80px rgba(0, 0, 0, 0.05);
  opacity: 1;
  backdrop-filter: blur(10px);
  -webkit-backdrop-filter: blur(10px);
  border-radius: 30px;
  color: #3c4b64 !important;
  font-size: 28px;
}
.page-title {
  position: absolute;
  z-index: 99;
  top: 15%;
  left: 50%;
  width: 50%;
  margin-left: -25%;
  text-align: center;
  font-size: 25px;
}
@media screen and (max-width: 768px) {
  .page-title {
    width: 90%;
    margin-left: -45%;
  }
}
.dot-top {
  margin-top: 100px;
}
#dot {
  border: 5px dashed var(--unnamed-color-ffffff);
  border: 5px dashed #fff;
  width: 0;
  position: fixed;
  display: none;
}
.box-radius {
  /*background: transparent
    linear-gradient(115deg, #d9d9d9 0%, var(--unnamed-color-e2e2e2) 100%) 0% 0%
    no-repeat padding-box; */
  box-shadow: -8px -8px 20px var(--unnamed-color-ffffff);
  /*background: transparent linear-gradient(115deg, #d9d9d9 0%, #e2e2e2 100%) 0%
    0% no-repeat padding-box;*/
  box-shadow: -8px -8px 20px #ffffff;
  background: #f3f3f3;
  border-radius: 150px;
  opacity: 1;
}
.aligner {
  display: flex;
  align-items: center;
  justify-content: center;
}
.text-bold {
  font-weight: bold;
}
.text-lg {
  font-size: 32px;
}
.text-md {
  font-size: 25px !important;
}

.toggle-header {
  background: var(--unnamed-color-ffffff) 0% 0% no-repeat padding-box;
  background: rgba(255, 255, 255, 0.5);
  opacity: 1;
  backdrop-filter: blur(10px);
  -webkit-backdrop-filter: blur(10px);
  border-radius: 25px;
  padding: 20px;
  z-index: 2;
  font-size: 24px;
}
.toggle-body {
  padding: 20px;
  background-color: hsla(0, 0%, 92.2%, 0.5);
  border-radius: 25px;
  padding-top: 90px;
  margin-top: -76px;
  z-index: 1;
}
.z-1 {
  z-index: 1;
}
.z-2 {
  z-index: 2;
}
.image-container img {
  width: 100%;
}
.text-navy {
  color: #3c4b64 !important;
}
</style>
